import gql from 'graphql-tag'
export default gql`mutation updateAttestMutation($attestId: Int!, $attest: BaseAttest!) {
  updateAttest(attestId: $attestId, attest: $attest) {
    attestNumber
    expirationDate
    id
  }
}`